import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LangueService {
  public readonly langEN = 'en';
  public readonly langFR = 'fr';

  public getCurrentLanguage(): string {
    const langOfDocument = document.documentElement.lang;
    if (langOfDocument.toLowerCase() === this.langEN) {
      return this.langEN;
    }
    return this.langFR;
  }
}
